module.exports = __webpack_public_path__ + "static/img/sample02.496465fa.svg";